import React, { createContext, useState, useEffect } from 'react';

export const WidthContext = createContext();

export const WidthProvider = ({ children }) => {
  const [currentWidth, setCurrentWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setCurrentWidth(window.innerWidth);
  };

  useEffect(() => {
    handleResize(); 

 
    window.addEventListener('resize', handleResize);
    

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); 

  return (
    <WidthContext.Provider value={{ currentWidth }}>
      {children}
    </WidthContext.Provider>
  );
};
